module.exports = {"440113007":"市桥街道","440113008":"沙头街道","440113009":"东环街道","440113010":"桥南街道","440113011":"小谷围街道","440113012":"大石街道","440113013":"洛浦街道","440113014":"石壁街道","440113015":"钟村街道","440113016":"大龙街道","440113017":"沙湾街道","440113102":"南村镇","440113103":"新造镇","440113104":"化龙镇","440113105":"石楼镇","440113120":"石碁镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440113.json
// module id = 2077
// module chunks = 0